import { render, staticRenderFns } from "./Excusar.vue?vue&type=template&id=0b0e4d20&"
import script from "./Excusar.vue?vue&type=script&lang=js&"
export * from "./Excusar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports